// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".table-row-overflow_2SlWqENDQk2ZLIkJWpYbtw{display:block;overflow-x:auto;white-space:nowrap}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/cafeDiscounts/styles.scss"],"names":[],"mappings":"AAAA,2CACE,aAAc,CACZ,eAAgB,CAChB,kBAAmB","file":"styles.scss","sourcesContent":[":local(.table-row-overflow){\n  display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n}"]}]);
// Exports
exports.locals = {
	"table-row-overflow": "table-row-overflow_2SlWqENDQk2ZLIkJWpYbtw"
};
module.exports = exports;
